require('angular');
module.exports = angular.module('AnimationsData',[])
.constant(
    'animations_data', [
        {
            thumbnail: 'img/animacje/sezonowe-zmiany-400x289.jpg',
            title: 'Sezonowe zmiany wysokości słońca - pory roku',
            page: 'film.php?ytid=IFSI4BXrTu8',
        },
        {
            thumbnail: 'img/animacje/barwy-nieba-400x289.jpg',
            title: 'Barwy nieba',
            page: 'film.php?ytid=QY6nlT3emZ8'
        },
        {
            thumbnail: 'img/animacje/skad-widac-400x289.jpg',
            title: 'Skąd widać najwięcej',
            page: 'film.php?ytid=F8_IuE8XcJo'
        },
        {
            thumbnail: 'img/animacje/demo-ruchu-ob-400x289.jpg',
            title: 'Demonstracja ruchu obiektów astronomicznych',
            page: 'film.php?ytid=-fe2hiITURg'
        },
        {
            thumbnail: 'img/animacje/ruch-gwiazd-400x289.jpg',
            title: 'Ruch gwiazd względem horyzontu',
            page: 'film.php?ytid=smLeY2Q0UX0'
        },
        {
            thumbnail: 'img/animacje/ruch-slonca-wzgledem-gwiazd-400x289.jpg',
            title: 'Ruch słońca względem gwiazd',
            page: 'film.php?ytid=zw2F-45PfBI'
        },
        {
            thumbnail: 'img/animacje/paralaksa-ogolna-400x289.jpg',
            title: 'Paralaksa - ogólna idea',
            page: 'film.php?ytid=dyZ5do1V4D8'
        },
        {
            thumbnail: 'img/animacje/paralaksa-gwiazd-400x289.jpg',
            title: 'Paralaksa gwiazd',
            page: 'film.php?ytid=gHb-Cdj1sVU'
        }
    ]
);


//////////////////
// WEBPACK FOOTER
// ./jssrc/animations-data.js
// module id = 4
// module chunks = 2